<template>
  <div class="dongguogaikuang">
    <div class="main">
      <div class="title">韩国东国大学简介</div>
      <div class="content">
        <span
          >东国大学创立于 1906
          年，至今已有百年历史，是韩国一所极富盛名的综合研究型大学。在 2021 年
          QS 世界大学排名中跻身世界 500 强， QS 亚洲大学排名位列第 96
          位。作为综合大学中影视传媒教育领域的标杆院校，东国大学的人文类、传媒类、戏剧电影类专业排名一直稳居韩国高校前列，在这些专业领域又以新闻传媒、演艺界、文化界名人辈出的戏剧电影系和影像研究生院而闻名。学校还拥有业界领先的影视教学与制作中心
          ― 忠武路影像中心。</span
        >
      </div>
      <div class="daxue">
        <img src="../../assets/images/dongguogaikuang/daxue.png" alt="" />
      </div>
      <a href="/introduction.html" target="_blank" class="button">查看更多</a>
      <div class="title">韩国东国大学名人校友</div>
      <!-- 轮播图 -->
      <div class="myswiper width870">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in DataList" :key="index">
            <img :src="item.Extend1" alt="韩国东国大学" />
            <div class="sceneryList_text">
              <p>{{ item.Extend2 }}</p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <a href="/zhimingxiaoyou.html" target="_blank" class="button">查看更多</a>
      <div class="title">韩国东国大学校园风景</div>
    </div>
    <div class="fengjing">
      <img src="../../assets/images/dongguogaikuang/fengjing.png" alt="" />
    </div>
    <div class="main">
      <a href="/xyfj.html" target="_blank" class="button">查看更多</a>
      <div class="title">韩国东国大学宣传视频</div>
      <div class="shipin">
        <ul>
          <li
            v-for="(item, index) in videoList"
            :key="index"
            @click="playVideo(item)"
          >
            <div class="imgs">
              <img :src="item.Extend10" alt="" />
              <!-- <video :src="item.InfoUrl"></video> -->
              <img
                src="../../assets/images/dongguogaikuang/bofang.png"
                class="bofang"
                alt=""
              />
            </div>
            <span>{{ item.Extend1 }}</span>
          </li>
        </ul>
      </div>
      <a href="/videoList.html" target="_blank" class="button">查看更多</a>
      <div class="title">韩国东国大学申请报名</div>
      <span class="biaoti">让你轻松实现学历提升的梦想</span>
      <!-- 表单 -->
      <div class="biaodanbox">
        <el-form :model="formLabelAlign" label-width="0px">
          <el-form-item>
            <p><span class="icon">*</span>您的姓名</p>
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <p><span class="icon">*</span>联系方式</p>
            <el-input
              v-model="formLabelAlign.phone"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item class="margbottom0">
            <p><span class="icon">*</span>当前学历</p>
            <el-select
              v-model="formLabelAlign.xueli"
              placeholder="请输入当前学历"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in xueliList"
                :key="item.S99_CodeId"
                :label="item.S99_Name"
                :value="item.S99_CodeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="project">
            <p>意向专业</p>
            <el-input
              v-model="formLabelAlign.zhuanye"
              placeholder="请输入意向专业"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="button" @click="subBtn">提 交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  components: {},
  name: "dongguogaikuang",
  metaInfo() {
    return {
      title: `东国概况-韩国东国大学中文官网`,
      meta: [
        {
          name: "keywords",
          content: "东国大学介绍,东国大学图片,东国大学",
        },
        {
          name: "description",
          content:
            "韩国东国大学中文官网为留学生提供韩国东国大学简介、东国大学介绍、东国大学图片，韩国东国大学中文官网全程为您的韩国留学生涯保驾护航。",
        },
      ],
    };
  },
  data() {
    return {
      //韩国东国大学名人校友列表
      DataList: [],
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
         pagination:{
          el:'.swiper-pagination',
          clickable:true,
        },
      },
      //韩国东国大学宣传视频列表
      videoList: [],
      //form表单
      formLabelAlign: {
        name: "",
        phone: "",
        xueli: "",
        zhuanye: "",
      },
      //学历
      xueliList: [],
    };
  },
    activated() {
    this.$emit("handleTKD", "东国概况");
  },
  mounted() {
    //获取名人校友列表
    this.getDataList();
    //获取宣传视频列表
    this.getVideoList();
    //获取form表单学历
    this.$axios
      .post("/trip/TokenPass/GetClueCode", {
        S99_GroupCode: "035",
      })
      .then((res) => {
        res.data.Data.forEach((element) => {
          this.xueliList.push(element);
        });
      });
  },
  methods: {
    //获取名人校友列表
    getDataList() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 411,
          index: 1,
          size: 4,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.DataList = res.data.Data.list;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    //获取宣传视频列表
    getVideoList() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 413,
          index: 1,
          size: 2,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.videoList = res.data.Data.list;
            console.log(this.videoList);
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    // 表单提交
    subBtn() {
      let _form = this.formLabelAlign;
      if (!_form.name) {
        this.$message.error("姓名不能为空！");
        return false;
      }
      if (!this.formLabelAlign.phone) {
        this.$message.error("手机号码不能为空！");
        return true;
      } else {
        if (!Number(this.formLabelAlign.phone)) {
          this.$message.error("手机号码只能为数字类型！");
          this.formLabelAlign.phone = "";
          return false;
        }
      }
      if (!_form.xueli) {
        this.$message.error("当前学历不能为空！");
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          EducationCode: _form.xueli, //当前学历
          C01_Major: _form.zhuanye, //意向专业
          C01_Origin: 239, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.$message.success("提交成功！");
            this.formLabelAlign.name = "";
            this.formLabelAlign.phone = "";
            this.formLabelAlign.xueli = "";
            this.formLabelAlign.zhuanye = "";
          } else {
            this.$message.error(res.data.Message);
          }
        });
    },
    playVideo(item) {
      this.$router.push(`/videocontent/${item.WebsiteContentId}.html`);
    },
  },
};
</script>

<style scoped lang="scss">
.dongguogaikuang {
  padding-top: 134px;
  .main {
    padding-left: 40px;
    padding-right: 40px;
    width: 100%;
    .title {
      width: 100%;
      margin-top: 60px;
      text-align: center;
      line-height: 39px;
      height: 39px;
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #f7901e;
    }
    .content {
      padding-top: 38px;
      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 40px;
      }
    }
    .daxue {
      padding-top: 40px;
      img {
        width: 100%;
      }
    }
    .button {
      display: block;
      width: 193px;
      height: 42px;
      text-decoration: none;
      margin: 40px auto 0;
      text-align: center;
      line-height: 42px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      color: #ffffff;
      background: #f7901e;
    }
    /deep/.myswiper {
      margin-top: 42px;
      width: 100%;
      position: relative;
      .swiper-container {
        height: 304px;
        .swiper-wrapper {
          .swiper-slide {
             width: 190px !important;
            height: 252px;
            img {
              display: block;
              // 使图片展示不压缩
              object-fit: cover;
              width: 210px;
              height: 252px;
            }
            .sceneryList_text {
              position: absolute;
              bottom: 0px;
              width: 210px;
              height: 36px;
             background-color: rgba(0,0,0,0.5);
              p {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                line-height: 36px;
                text-align: center;
              }
            }
          }
        }
        .swiper-pagination {
           bottom: -9px;
          .swiper-pagination-bullets {
            width: 11px;
            height: 11px;
            background: #d2d2d2;
            opacity: initial;
            margin: 0 13px;
          }
          .swiper-pagination-bullet-active {
            background: #ff740e;
          }
        }
      }
    }
    .shipin {
      margin-top: 40px;
      ul {
        display: flex;
        li {
          margin-right: 24px;
          text-align: center;
          .imgs {
            position: relative;
            img {
              width: 323px;
              height: 180px;
            }
            .bofang {
              width: 51px;
              height: 51px;
              position: absolute;
              z-index: 1;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }
          }
          span {
            margin-top: 24px;
            display: block;
            width: 323px;
            height: 23px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            color: #333333;
            line-height: 23px;
            overflow: hidden;
            white-space: nowrap;
            -o-text-overflow: ellipsis; /* for Opera */
            text-overflow: ellipsis; /* for IE */
          }
        }
        :nth-lastchild() {
          margin-right: 0;
        }
      }
    }
    .biaoti {
      display: block;
      margin-top: 19px;
      text-align: center;
      height: 29px;
      font-size: 30px;
      font-family: Source Han Sans CN;
      color: #333333;
      line-height: 29px;
    }
    //表单
    .biaodanbox {
      width: 100%;
      margin: 0 auto;
      padding: 0 35px;
      /deep/.el-form {
        width: 600px;
        margin: 0 auto;
        position: relative;
        margin-top: 40px;
        .el-form-item {
          margin-bottom: 20px;
          p {
            display: flex;
            position: absolute;
            z-index: 1;
            top: 3px;
            left: 27px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            .icon {
              color: #e83323;
            }
          }
          .el-select,
          .el-input {
            width: 100%;
          }
          .el-select-dropdown__item {
            span {
              font-size: 26px;
            }
          }
          .el-input__suffix {
            right: 35px;
            .el-input__suffix-inner {
              .el-input__icon {
                font-size: 26px;
              }
            }
          }
          .el-form-item__content {
            .el-input__inner {
              width: 100%;
              height: 77px;
              padding-left: 164px;
              font-size: 20px;
              line-height: 77px;
              background: #ffffff;
              border: 2px solid #d9d9d9;
              border-radius: 4px;
              letter-spacing: 2px;
            }
          }
        }
        .project {
          margin-top: 20px;
          p {
            left: 41px;
          }
        }
        .margbottom0 {
          margin-bottom: 0px;
        }
      }
      .button {
        width: 600px;
        height: 77px;
        background: #f7901e;
        border-radius: 5px;
        text-align: center;
        line-height: 77px;
        margin: 0 auto;
        cursor: pointer;
        font-size: 28px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
        font-family: Source Han Sans CN;
        color: #ffffff;
        margin-top: 40px;
        margin-bottom: 61px;
      }
    }
  }
  .fengjing {
    width: 750px;
    margin-top: 40px;
    img {
      width: 100%;
    }
  }
}
</style>
